import {toAbsoluteUrl} from "../../_metronic/helpers";

export interface IComponent {
  alt?: string;
  src?: string;
  small?: boolean;
}

export default function (props: IComponent) {
  if (props.small) {
    return <>
      <img
        alt='Logo'
        src={toAbsoluteUrl('media/logos/nerdteam-logo.svg')}
        className='h-25px app-sidebar-logo-minimize theme-light-show'
      />
      <img
        alt='Logo'
        src={toAbsoluteUrl('media/logos/nerdteam-logo-dark.svg')}
        className='h-25px app-sidebar-logo-minimize theme-dark-show'
      />
    </>
  }

  return <>
    <img
      alt='Logo'
      src={toAbsoluteUrl('media/logos/nerdteam-logo.svg')}
      className='h-50px app-sidebar-logo-default theme-light-show'
    />

    <img
      alt='Logo'
      src={toAbsoluteUrl('media/logos/nerdteam-logo-dark.svg')}
      className='h-50px app-sidebar-logo-default theme-dark-show'
    />
  </>
}
